import styled from "styled-components";
import { DropShadowBlack2 } from "../../theme/Mixins";

export const StyledFillerImage = styled.img`
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  border-radius: 1rem;
  ${DropShadowBlack2}
`;

const FillerImage = (props) => {
  return <StyledFillerImage {...props} />;
};

export default FillerImage;
